module.exports = __webpack_public_path__ + "images/recommended.fca8f1d42cc312606f0edafc5fc08f6f.png";